import {css} from 'emotion'
import { Colors, SliderLabel } from './../'

export const CheckboxStyle =  (checked) => css({
  'input[type="checkbox"]': {
    display: 'none',
  },
  'label': {
    ...SliderLabel,
    position: 'relative',
    color: Colors.mediumGrey,
    paddingLeft: '1.5rem',
    lineHeight: 1.4,
    transition: 'color 200ms ease',
    '&:hover': {
      color: 'black',
    },
    '&:before': {
      content:"''",
      position: 'absolute',
      top: 0,
      left: 0,
      border: `2px solid ${ checked ? 'black' : Colors.mediumGrey}`,
      width: 10,
      height: 10,
    },
    '&:after' : {
      content:"''",
      position: 'absolute',
      top: 4,
      left: 4,
      background: 'black',
      width: 6,
      height: 6,
      opacity: checked ? 1 : 0,
      transform: `scale(${checked ? 1 : 2})`,
      transition: 'all .2s ease'
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/checkbox.js